<template>
  <div class="app-container">
    <el-card class="mb5">
      <el-form
        ref="form"
        :model="queryForm.params"
        label-width="auto"
        size="small"
        label-position="top"
      >
        <div class="searchContainer">
          <el-row :gutter="10">
            <el-col :span="6">
              <!--账单时间-->
              <el-form-item :label="$t('receivablePayable.BillingDate')" prop="payableTimes">
                <el-date-picker
                  v-model="queryForm.params.payableTimes"
                  style="width: 100%"
                  type="daterange"
                  :range-separator="$t('operationCenter.to')"
                  :start-placeholder="$t('operationCenter.startDate')"
                  :end-placeholder="$t('operationCenter.endDate')"
                  value-format="yyyy-MM-dd"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--对账状态-->
              <el-form-item :label="$t('receivablePayable.ReconciliationStatus')" prop="auditStatus">
                <el-select
                  v-model="queryForm.params.auditStatus"
                  filterable
                  multiple
                  :placeholder="$t('operationCenter.PleaseSelect')"
                  clearable
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in AUDIT_STATUS"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--应付主体-->
              <el-form-item :label="$t('basicData.PayablePrincipal')" prop="providerId">
                <QueryProviderCmp
                  :val="queryForm.params.providerId"
                  @change="changeProvider"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--网点-->
              <el-form-item :label="$t('basicData.Outlets')" prop="siteIds">
                <QuerySiteCmp
                  ref="querySiteCmp"
                  :val="queryForm.params.siteIds"
                  :provider-id="queryForm.params.providerId"
                  :payable-types="queryForm.params.payableTypes"
                  :clearable="true"
                  :multiple="true"
                  :multiple-limit="10"
                  @change="val => queryForm.params.siteIds = val"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--业务类型-->
              <el-form-item :label="$t('collectionCenter.businessType')" prop="businessType">
                <el-select
                  v-model="queryForm.params.businessType"
                  filterable
                  :placeholder="$t('operationCenter.PleaseSelect')"
                  clearable
                  style="width: 100%;"
                >
                  <!--全部-->
                  <el-option :label="$t('basicData.all')" :value="null" />
                  <el-option
                    v-for="item in P_BUSINESS_TYPE"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--账单类型-->
              <el-form-item :label="$t('collectionCenter.TypeBill')" prop="payableTypes">
                <el-select
                  v-model="queryForm.params.payableTypes"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  style="width: 100%"
                  clearable
                >
                  <el-option
                    v-for="item in payableType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--是否请款-->
              <el-form-item :label="$t('receivablePayable.areYouRequestingPayment')" prop="requestPaymentStatus">
                <el-select
                  v-model="queryForm.params.requestPaymentStatus "
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  style="width: 100%"
                  clearable
                >
                  <!--全部-->
                  <el-option :label="$t('GlobalSetObj.all')" value="" />
                  <!--是-->
                  <el-option :label="$t('GlobalSetObj.yes')" :value="1" />
                  <!--否-->
                  <el-option :label="$t('GlobalSetObj.No')" :value="0" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--账单批次号-->
              <el-form-item :label="$t('receivablePayable.BillingBatchNumber')" prop="billBatchNumber">
                <InputTextareaCmp
                  ref="inputTextareaRef" :val="queryForm.params.billBatchNumber" :max-length="200"
                  @input="(_, val) => queryForm.params.billBatchNumber = val"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="searchResources"
      >
        {{ $t('operationCenter.Procurar') }}
      </el-button>
      <!--重 置-->
      <el-button
        size="small"
        icon="el-icon-refresh"
        @click="onReset"
      >{{ $t('basicData.reset') }}</el-button>
    </el-card>

    <el-card>
      <div class="feet-s mb10">
        <div class="feet-r">
          <!--审核-->
          <el-button
            v-permit:remove="'btn:finance:accountsPayableReview:billReview:examine'"
            :disabled="!isReview"
            size="small"
            type="primary"
            @click="operationBtn(3)"
          >{{ $t('receivablePayable.examine') }}</el-button>

          <!--撤回-->
          <el-button
            v-if="isBatchReview"
            :disabled="!isRevoke"
            size="small"
            type="danger"
            class="feet-btn"
            @click="recallAll()"
          >{{ $t('receivablePayable.withdraw') }}</el-button>

          <!--自定义栏目-->
          <CustomStatusBar
            class="feet-btn"
            :columns-data="TABLE_HEADER"
            :params="searchParams"
            :save-params="customParams"
            @updateColumns="updateColumns"
          />

          <el-popover
            placement="bottom-start"
            trigger="hover"
          >
            <div class="feet">
              <!--标记请款-->
              <el-button
                size="small"
                type="warning"
                @click="operationBtn(1)"
              >{{ $t('receivablePayable.markPaymentRequest') }}</el-button>
              <!--取消请款-->
              <el-button
                size="small"
                class="feet-btn"
                @click="operationBtn(2)"
              >{{ $t('receivablePayable.cancelPaymentRequest') }}</el-button>
            </div>
            <!-- 请款 -->
            <template #reference>
              <el-button
                v-permit:remove="'btn:finance:accountsPayableReview:billReview:paymentRequest'"
                type="success"
                size="small"
              >{{ $t('receivablePayable.paymentRequest') }}</el-button>
            </template>
          </el-popover>

          <TableStatisticiansCmp :table-data="tableData" />
        </div>

        <!-- 导出 -->
        <el-button
          v-permit:remove="'btn:finance:accountsPayableReview:billReview:export'" size="small"
          @click="onExport"
        >{{ $t('CenterForSorting.export') }}<i class="el-icon-download el-icon--right" /></el-button>
      </div>

      <el-table
        ref="table"
        :key="tableKey"
        :data="tableData"
        class="table-height"
        :height="tableHeightRow.height"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column :label="$t('operationCenter.ind')" width="60px" align="center">
          <template slot-scope="scope">
            <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, ind) in currentColumns"
          :key="ind"
          :prop="item.prop"
          :label="item.label"
          :align="item.align"
          :min-width="item.width"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <!--账单批次号-->
            <div v-if="item.prop === 'billBatchNumber'">
              <div class="batchNumber" @click="showBillBatchNumber(scope.row)">{{ scope.row.billBatchNumber }}</div>
            </div>

            <!-- 业务类型 -->
            <div v-else-if="item.prop === 'businessType'">
              {{ P_BUSINESS_TYPE[scope.row.businessType] && P_BUSINESS_TYPE[scope.row.businessType].label || '' }}
            </div>

            <!-- 账单类型 -->
            <div v-else-if="item.prop === 'payableType'">
              {{ PAYABLE_TYPE[scope.row.payableType] && PAYABLE_TYPE[scope.row.payableType].label || '' }}
            </div>

            <!-- 账单状态 -->
            <div v-else-if="item.prop === 'billStatusValue'">
              {{ AUDIT_STATUS[scope.row.billStatusValue] && AUDIT_STATUS[scope.row.billStatusValue].label || '' }}
            </div>

            <!--是否请款-->
            <div v-else-if="item.prop === 'requestPaymentStatus'">
              <el-tag :type="scope.row.requestPaymentStatus === 1 ? 'success' : 'danger'">{{ scope.row.requestPaymentStatus === 1 ? $t('GlobalSetObj.yes') : $t('GlobalSetObj.No') }}</el-tag>
            </div>

            <div v-else>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
        <!--操作-->
        <el-table-column
          :label="$t('basicData.operate')"
          align="center"
          width="140"
          fixed="right"
          :show-overflow-tooltip="true"
        >
          <template #default="scope">
            <!--  只能撤回当前登录人单据 且状态为待审核、未通过 -->
            <div
              v-if="[0, 2].includes(scope.row.auditStatus) && $store.state.user.id === scope.row.createUser"
            >
              <el-button
                v-permit:remove="'btn:finance:accountsPayableReview:billReview:withdraw'"
                type="danger"
                size="mini"
                @click="recall(scope.row)"
              >{{ $t('receivablePayable.withdraw') }}</el-button><!--撤回-->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="queryForm.pageNumber"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size.sync="queryForm.pageSize"
          :total="total"
          background
          style="margin: 10px 0"
          @current-change="getCurrentPage"
          @size-change="getSizePage"
        />
      </div>
    </el-card>

    <!--  对账批次详情  -->
    <el-drawer
      :title="$t('receivablePayable.ReconcileBatchDetails') + '-' + batchNumber"
      :append-to-body="true"
      :visible.sync="showDetail"
      direction="ltr"
      custom-class="drawerClass"
      :label="$t('receivablePayable.ReconcileBatchDetails')"
      size="80%"
    >
      <BatchNumberDetail
        :key="batchNumberKey"
        :batch-number="batchNumber"
        :bill-batch-data="billBatchData"
        :select-key="1"
        @closeDetail="closeDetail"
      />
    </el-drawer>

    <!--审核-->
    <ReviewDialog
      ref="reviewDialog"
      :data="selectData"
      :type="1"
      @change="getExaminePage"
    />
  </div>
</template>

<script>
import {
  apiPayableSiteBillGetPage,
  apiPayableSiteBillWithdraw,
  apiPayableSiteBillExport,
  apiPayableSiteBillRequestPaymentOperation,
  payableSiteBillBatchWithdraw
} from '@/api/finance/receivables';
import { cloneDeep } from 'lodash-es';
import { goFinanceExportPage } from '@/utils/goExportList.js';
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight.js';
import { P_BUSINESS_TYPE, AUDIT_STATUS, PAYABLE_TYPE } from '@/views/finance/enums.js';
import { TABLE_HEADER } from '../utils';

export default {
  name: 'BillReview',

  components: {
    TableStatisticiansCmp: () => import('../cmp/TableStatisticiansCmp.vue'),
    QuerySiteCmp: () => import('@/views/finance/cmp/Query/QuerySiteCmp.vue'),
    InputTextareaCmp: () => import('@/views/finance/cmp/Query/InputTextareaCmp.vue'),
    QueryProviderCmp: () => import('@/views/finance/cmp/Query/QueryProviderCmp.vue'),
    CustomStatusBar: () => import('@/components/customStatusBar/index.vue'),
    BatchNumberDetail: () => import('@/views/finance/payableManage/cmp/batchNumberDetail.vue'),
    ReviewDialog: () => import('../cmp/reviewDialog.vue')
  },

  mixins: [estimateTableHeight],

  data() {
    return {
      TABLE_HEADER, // 表头
      PAYABLE_TYPE, // 账单类型
      P_BUSINESS_TYPE, // 业务类型
      AUDIT_STATUS,
      queryForm: {
        orderDirection: 'DESC',
        pageNumber: 1,
        pageSize: 10,
        params: {
          billBatchNumber: '', // 对账单批次号
          auditStatus: [0, 2], // 对账状态
          siteIds: [],
          providerId: '', // 主体
          businessType: null, // 业务类型
          payableTypes: '', // 账单类型
          payableTimes: [], // 账单时间
          requestPaymentStatus: '' // 是否请款
        }
      },
      showDetail: false,
      tableData: [],
      total: 0,
      height: 100,
      tableKey: new Date().getTime(),
      batchNumberKey: new Date().getTime(),
      batchNumber: '',
      billBatchData: {},
      selectData: [],
      currentColumns: [],
      searchParams: {
        type: 0,
        menuEnum: 'copeAudits'
      },
      customParams: {
        templateField: '',
        templateName: '应付账单审核',
        userId: '',
        type: 0,
        menuEnum: 'copeAudits'
      }
    };
  },

  computed: {
    // 无法审核自己单据
    isReview() {
      if (this.selectData.length > 0) {
        return this.selectData.every(item => this.$store.state.user.id !== item.createUser);
      }
      return false;
    },
    // 批量审核权限
    isBatchReview() {
      const isBool = this.$store.getters.button_permissions.includes('btn:finance:accountsPayableReview:billReview:withdraw');
      const isAllBool = this.$store.getters.button_permissions.includes('btn:finance:accountsPayableReview:billReview:withdrawAll');
      console.log('isBatchReview', isBool, isAllBool);
      return isBool || isAllBool;
    },
    // 撤回权限
    // 1 管理员批量撤回 2 登录人批量撤回
    isRevoke() {
      const isBool = this.$store.getters.button_permissions.includes('btn:finance:accountsPayableReview:billReview:withdraw');
      const isAllBool = this.$store.getters.button_permissions.includes('btn:finance:accountsPayableReview:billReview:withdrawAll');
      // 管理员批量撤回
      if (isAllBool && this.selectData.length > 0) {
        return this.selectData.every(item => [0, 2].includes(item.auditStatus));
      }
      // 登录人批量撤回
      if (isBool && this.selectData.length > 0) {
        return this.selectData.every(item => [0, 2].includes(item.auditStatus) && this.$store.state.user.id === item.createUser);
      }
      return false;
    },
    payableType() {
      // 过滤掉 key 为 5 的数据 (运输 (干/支线))
      const filtered = {};
      Object.keys(PAYABLE_TYPE).forEach(key => {
        if (key !== '5') {
          filtered[key] = PAYABLE_TYPE[key];
        }
      });
      return filtered;
    }
  },

  created() {
    // 获取账单审核列表
    this.getExaminePage();
  },

  methods: {
    // 更新自定义栏目columns
    updateColumns(list) {
      this.$nextTick(() => {
        this.currentColumns = cloneDeep(list);
        this.tableKey = new Date().getTime();
      });
      // console.log(list, '列表呈现的columns');
    },

    // 主体选项变化
    changeProvider(val) {
      this.queryForm.params.providerId = val;
      this.queryForm.params.siteIds = [];
    },

    // 请求参数处理
    getQueryData() {
      const obj = cloneDeep(this.queryForm);

      if (obj.params.payableTypes !== '') {
        obj.params.payableTypes = [obj.params.payableTypes];
      } else {
        obj.params.payableTypes = [];
      }

      if (!Array.isArray(obj.params.payableTimes)) {
        obj.params.payableTimes = [];
      }

      obj.params.billBatchNumbers = [];
      // 账单批次号处理
      if (obj.params.billBatchNumber.length >= 1) {
        obj.params.billBatchNumbers = this.$refs.inputTextareaRef.getValue();
      }

      obj.params.billBatchNumber = undefined;
      console.log(obj, '查询参数');
      return obj;
    },

    // 列表数据勾选
    handleSelectionChange(arr) {
      this.selectData = arr;
    },

    // 获取对账批次详情
    showBillBatchNumber(data) {
      this.batchNumber = data.billBatchNumber;
      this.billBatchData = data;
      this.showDetail = true;
      this.batchNumberKey = new Date().getTime();
    },

    // 关闭详情
    closeDetail() {
      this.showDetail = false;
    },

    // 翻页
    getCurrentPage(val) {
      this.queryForm.pageNumber = val;
      this.getExaminePage();
    },

    // 每页显示数量变化
    getSizePage(val) {
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = val;
      this.getExaminePage();
    },

    // 搜索
    searchResources() {
      this.queryForm.pageNumber = 1;
      this.getExaminePage();
    },

    // 重置
    onReset() {
      this.$refs.form.resetFields();
      this.getExaminePage();
    },

    // 获取列表数据
    getExaminePage() {
      const row = this.getQueryData();
      apiPayableSiteBillGetPage(row).then(res => {
        if (res.code === 200) {
          this.tableData = (res.data.records || []).map(item => {
            return Object.freeze(item);
          });
          this.total = res.data.total;
        }
      }).catch(err => {
        console.error(err);
      });
    },

    /**
     * 操作按钮
     * @param type 3 审核 1 请款 2 取消请款
     */
    operationBtn(type) {
      if (type === 3) {
        if (this.selectData.length === 0) {
          this.$message.warning(this.$t('receivablePayable.SelectAtLeastOnePieceOfData')); // 最少要选择一条数据
          return;
        }
        this.$refs.reviewDialog.open();
      } else {
        const list = this.selectData.length > 0 ? this.selectData : this.tableData;
        const ids = list.map(item => item.id);
        apiPayableSiteBillRequestPaymentOperation({
          ids,
          requestPaymentStatus: type
        }).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('basicData.TheOperationSucceeded')); // 操作成功
            this.getExaminePage();
          }
        }).catch(err => {
          console.error(err);
        });
      }
    },

    // 撤回
    recall(row) {
      this.$confirm(this.$t('receivablePayable.AreYouSureYouWantToWithdraw'), this.$t('basicData.tips'), { // '确定要撤回?'
        confirmButtonText: this.$t('basicData.determine'), // '确定',
        cancelButtonText: this.$t('basicData.Cancel'), // '取消',
        type: 'warning'
      }).then(() => {
        apiPayableSiteBillWithdraw(row.id).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('basicData.TheOperationSucceeded'));
            this.getExaminePage();
          }
        });
      });
    },

    // 批量撤回
    recallAll() {
      if (this.selectData.length > 10) {
        this.$message.warning(this.$t('collectionCenter.SelectUpTo10PiecesOfData'));
        return;
      }
      if (this.selectData.length === 0) {
        this.$message.warning(this.$t('collectionCenter.PleaseSelectDataThatCanBeRecalled'));
        return;
      }
      const ids = this.selectData.map(item => item.id);
      this.$confirm(this.$t('receivablePayable.AreYouSureYouWantToWithdraw'), this.$t('basicData.tips'), { // '确定要撤回?'
        confirmButtonText: this.$t('basicData.determine'), // '确定',
        cancelButtonText: this.$t('basicData.Cancel'), // '取消',
        type: 'warning'
      }).then(() => {
        payableSiteBillBatchWithdraw(ids).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
            this.getExaminePage();
          }
        });
      });
    },

    // 导出
    onExport() {
      const { selectData } = this;
      const { params } = this.getQueryData();

      // 指定导出
      if (selectData.length > 0) {
        params.ids = [];
        selectData.map(item => {
          if (item.auditStatus !== 3) {
            params.ids.push(item.id);
          }
        });
      }

      apiPayableSiteBillExport(params).then(res => {
        goFinanceExportPage();
      }).catch(err => {
        console.error(err);
      });
    }
  }
};
</script>

<style scoped>
.batchNumber {
  color: #007efd;
  cursor: pointer;
}

.app-container .searchContainer /deep/ .el-date-editor .el-range-separator {
  line-height: 25px;
}
</style>
